`<app-layout class="container--md">
    <div class="inner-container">
      <div  class="container">
        <div class="row row-title">
          <p class="heading-h5-regular">PE Worklist</p>
        </div>
        <div class="toggle" *ngIf="isUserPE">
          <mat-button-toggle-group name="fontStyle" (change)="onWorklistChange($event)"  aria-label="Font Style">
            <mat-button-toggle value="worklist" [checked]="selectedButton === 'worklist'">My Worklist</mat-button-toggle>
            <mat-button-toggle value="peworklist" [checked]="selectedButton === 'peworklist'">PE Worklist</mat-button-toggle>
          </mat-button-toggle-group>
        </div>
    </div>
    <mat-tab-group (selectedIndexChange)="onSelectedIndexChange($event)" #formTabs dynamicHeight
      mat-stretch-tabs="false" mat-align-tabs="start">
      <div class="app-worklist">
        <mat-tab *ngFor="let tab of peWorkListTabs; let i = index">
          <ng-template mat-tab-label>
            {{ tab.label }} ({{ tab.badge }})
          </ng-template>
          <div class="app-worklists">
            <app-pe-worklist-listing *ngIf="isDataLoaded" [index]="i" [selectedIndex]="selectedIndex"
              [tabStatus]="tab.key" [initialData]="tab.data" [badgeCount]="tab.badge" (reloadEvent)="loadAllData()">
            </app-pe-worklist-listing>
            <div *ngIf="!isDataLoaded"><mat-spinner class="myworklist-spinner"></mat-spinner>
              <div class="myworklist-spinner-text">
                <p>Retrieving data...</p>
              </div>
            </div>
          </div>
        </mat-tab>
        <!-- <mat-tab label="To Do">
            <div class="app-worklists">
              <app-pe-worklist-listing [index]="0" [selectedIndex]="selectedIndex" [tabStatus]="'ToDo'">
              </app-pe-worklist-listing>
            </div>
          </mat-tab>
        </div>
        <div class="app-worklist">
          <mat-tab label="Done">
            <div class="app-worklists">
              <app-pe-worklist-listing [index]="1" [selectedIndex]="selectedIndex" [tabStatus]="'Done'">
              </app-pe-worklist-listing>
            </div>
          </mat-tab> -->
      </div>
    </mat-tab-group>
  </div>
</app-layout>